import { useEffect, useMemo } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'

import { getBankAccounts_API } from 'api/financials'
import { useBankAccountsStore } from 'store/financials'
import { hasingOut } from 'services/helpers'

export const useBankAccountsQuery = ({ traderId }: { traderId: number }) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useBankAccountsLookup'],
    queryFn: async () => {
      return await getBankAccounts_API({ traderId })
    },
  })
}

export const useBankAccount = () => {
  const { traderId } = useParams()
  const bankaccountsModStatus = useBankAccountsStore(
    (state) => state.bankaccountsModStatus
  )
  const bankaccountsModStatusSet = useBankAccountsStore(
    (state) => state.bankaccountsModStatusSet
  )
  const bankaccountsModErrors = useBankAccountsStore(
    (state) => state.bankaccountsModErrors
  )
  const bankaccountsModErrorsSet = useBankAccountsStore(
    (state) => state.bankaccountsModErrorsSet
  )
  const bankaccounts = useBankAccountsStore((state) => state.bankaccounts)
  const bankaccountsSet = useBankAccountsStore((state) => state.bankaccountsSet)

  const queryClient = useQueryClient()

  const {
    data: dataBankAccounts,
    isLoading: isLoadingBankAccounts,
    isError: isErrorBankAccounts,
    isFetching: isFetchingBankAccounts,
    isSuccess: isSuccessBankAccounts,
    error: errorBankAccounts,
  } = useBankAccountsQuery({ traderId: parseInt(traderId || '') })

  useEffect(() => {
    if (dataBankAccounts) bankaccountsSet(dataBankAccounts.bankAccounts)
  }, [dataBankAccounts, bankaccountsSet])

  useEffect(() => {
    // if (isFetchingBankAccounts) bankaccountsModStatusSet('loading')
    // if (isLoadingBankAccounts) bankaccountsModStatusSet('loading')
    if (isSuccessBankAccounts) bankaccountsModStatusSet('success')
    if (isErrorBankAccounts) bankaccountsModStatusSet('fail')
    if (errorBankAccounts)
      bankaccountsModErrorsSet(JSON.stringify(errorBankAccounts))
  }, [
    isFetchingBankAccounts,
    isLoadingBankAccounts,
    isSuccessBankAccounts,
    isErrorBankAccounts,
    errorBankAccounts,
    bankaccountsModStatusSet,
    bankaccountsModErrorsSet,
  ])

  const bankaccountsAsOptions = useMemo(() => {
    return bankaccounts.map((item) => ({
      label:
        `${hasingOut(item.bankAccountNumber)} - ${item.bankAccountName}` || '',
      value: item.bankAccountNumber.toString(),
    }))
  }, [bankaccounts])

  return {
    bankaccounts,
    bankaccountsAsOptions,
    bankaccountsModStatus,
  }
}

/*
"{"issues":[{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",0,"bankName"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",0,"firstTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",0,"lastTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",0,"note"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",0,"transSum"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",1,"bankName"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",1,"firstTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",1,"lastTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",1,"note"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",1,"transSum"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",2,"lastTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",2,"note"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",2,"transSum"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",3,"bankName"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",3,"firstTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",3,"lastTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",3,"note"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",3,"transSum"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",4,"lastTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",4,"transSum"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",5,"lastTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",5,"transSum"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",6,"lastTrans"],"message":"Expected string, received null"},{"code":"invalid_type","expected":"string","received":"null","path":["bankAccounts",6,"transSum"],"message":"Expected string, received null"}],"name":"ZodError"}"
*/
